import styled from 'styled-components';
import {device} from '../../../../utils/utils';
import myGraphic from '../../assets/my-graphics.png';

export const PartnrHrBnr = styled.div`
  //box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  display: flex;
  align-items: center;
  min-height: 114px;
  overflow: hidden;
  //margin-top: -40px;
  margin-bottom: 80px;
  position: relative;
  padding: 0 30px 0 0;
  //background: #FFFFFF url(${myGraphic}) 80% 17px no-repeat;
  //background-size: 101px 79px;
  @media ${device.mobileS} {
    background-image: none;
    flex-direction: column;
    padding: 20px;
    align-items: flex-start;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 0;
    position: relative;
    overflow: hidden;
  }
`;
export const PartnrHrBnrIcon = styled.div`
  width: 179px;
  flex-shrink: 0;
  @media ${device.mobileS} {
    position: absolute;
    right: -50px;
    top: -50px;
  }
`;
export const PartnrHrBnrContent = styled.div`
  flex: 1;
`;
export const PartnrHrBnrHdng = styled.h4`
  font-size: 28px;
  line-height: 38px;
  font-weight: 300;
  color: #4e3f6e;
  span {
    font-weight: 900;
  }
  @media ${device.mobileS} {
    font-size: 24px;
    line-height: 28px;
    max-width: 190px;
  }
`;
export const PartnrHrBnrSubHdng = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #2b2c4a;
  margin-top: 4px;
  span {
    font-weight: 900;
  }
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 18px;
    max-width: 215px;
    margin-top: 16px;
  }
`;
export const PartnrHrBnrCta = styled.button`
  background: linear-gradient(131.54deg, #53b2fe -11.7%, #065af3 158.39%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 36px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #fff;
  flex-shrink: 0;
  margin-left: 35px;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-family: 'Lato';
  @media ${device.mobileS} {
    margin-left: unset;
    margin-top: 18px;
  }
`;
